import { List } from "immutable";
import * as actions from "../actions/CountryActions";
import { CountryState, initialState } from "../store/CountryState";
import buildReducer from "../utils/ReducerBuilder";

export const CountryReducer = buildReducer<CountryState>(initialState)
    .handle(actions.onAllReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            countries: List(action.payload.countries),
        };
    })
    .handle(actions.onInitialized, (state, action) => {
        return {
            ...state,
            initialized: action.payload || false,
        };
    })
    .handle(actions.onLoading, (state, action) => {
        return {
            ...state,
            loading: action.payload || false,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/CountryReducer.ts